import { Store } from "pullstate";

const ApplicationStore = new Store({
    isLoading: false
});

const useApplication = () => {
    const isLoading = ApplicationStore.useState(s => s.isLoading);

    const setIsLoading = (state: boolean) => {
        ApplicationStore.update(s => { s.isLoading = state });

    }

    return {
        isLoading, setIsLoading
    }
}

export default useApplication;